import diplomadoDocencia from '../../assets/img/cursos/diplo/diplomado-docencia-universitaria.jpeg';
import './Diplomados.css';

const objetivos = [
  'Desarrollar competencias pedagógicas para la educación superior.',
  'Implementar metodologías de enseñanza innovadoras.',
  'Mejorar las técnicas de evaluación y retroalimentación.',
];

const temas = [
  ['Módulo 1:', 'Teorías del aprendizaje.'],
  ['Módulo 2:', 'Currículo y evaluación por competencias.'],
  ['Módulo 3:', 'Didáctica en la educación superior.'],
  ['Módulo 4:', 'Educación Inclusiva.'],
  ['Módulo 5:', 'Neuroeducación.'],
  ['Módulo 6:', 'Diseño universal de aprendizaje.'],
];

const datosDiplomado = [
  ['Contenido', '6 módulos'],
  ['Fecha y horario', '16 de mayo de 2026 · 01:30 PM - 05:30 PM'],
  ['Modalidad', 'Clases Presenciales'],
  ['Incluye', 'Taller “PIAR”'],
  ['Certificación', 'Certificado y material de estudio'],
  ['Lugar', 'Troncal de Occidente, barrio Santa Cecilia'],
  ['Contacto', '(57) 312 743 1631'],
  ['Sitio web', 'www.institutocruzrojasucre.edu.co'],
  ['Dirección', 'Calle 38 No. 29-18, Carretera Troncal, Sincelejo - Sucre.'],
];

const DiplomadoDocenciaUniversitaria = () => (
  <main className="oferta-academica-page diplomado-detalle-page">
    <section className="diplomado-detalle-hero" aria-labelledby="diplomado-detalle-titulo">
      <div className="diplomado-detalle-copy">
        <p className="oferta-eyebrow">Diplomados</p>
        <h1 id="diplomado-detalle-titulo">Diplomado en Docencia Universitaria</h1>
        <p className="diplomado-detalle-enfasis">Con énfasis en Educación Inclusiva</p>
        <span className="oferta-accent" aria-hidden="true" />
        <p className="diplomado-detalle-introduccion">
          Descubre nuestro Diplomado en Docencia Universitaria, diseñado para brindarte las herramientas y conocimientos necesarios para destacarte en el ámbito educativo superior.
        </p>
        <a
          className="oferta-primary-button"
          href="https://site3.q10.com/Preinscripcion?aplentId=f7bb9af6-4333-4e98-983c-cef7025ecc99"
          target="_blank"
          rel="noreferrer"
        >
          Inscríbete Ahora <span aria-hidden="true">↗</span>
        </a>
      </div>
      <div className="diplomado-detalle-imagen">
        <img
          src={diplomadoDocencia}
          alt="Afiche del Diplomado en Docencia Universitaria con énfasis en Educación Inclusiva"
          decoding="async"
        />
      </div>
    </section>

    <section className="diplomado-detalle-informacion" aria-label="Información del Diplomado en Docencia Universitaria">
      <div className="diplomado-informacion-heading">
        <p className="oferta-eyebrow">Docencia Universitaria</p>
        <h2>Información del diplomado</h2>
      </div>

      <article className="diplomado-descripcion-card">
        <p className="oferta-eyebrow">Descripción:</p>
        <p>Este diplomado te permitirá desarrollar habilidades pedagógicas avanzadas, metodologías de enseñanza innovadoras y técnicas de evaluación efectivas para mejorar tu desempeño como docente universitario.</p>
      </article>

      <div className="diplomado-objetivos-card">
        <h2>Objetivos:</h2>
        <ul>
          {objetivos.map((objetivo) => <li key={objetivo}>{objetivo}</li>)}
        </ul>
      </div>

      <div className="diplomado-temas-card">
        <h2>Temas del diplomado</h2>
        <ul>
          {temas.map(([modulo, tema]) => (
            <li key={modulo}>
              <strong>{modulo}</strong>
              <span>{tema}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="diplomado-datos-heading">
        <h2>Información práctica</h2>
      </div>
      <dl className="diplomado-datos-grid">
        {datosDiplomado.map(([titulo, valor]) => (
          <div className="diplomado-dato-card" key={titulo}>
            <dt>{titulo}</dt>
            <dd>{valor}</dd>
          </div>
        ))}
      </dl>
    </section>
  </main>
);

export default DiplomadoDocenciaUniversitaria;
